const orderReportApi = {
  // 1、休店
  getReasonEnum: "/system/shop/restreasonenum", // 休店原因枚举
  getOffList: "/system/shop/restlistforshop", // 休店申请列表
  postOffStore: "/system/shop/submitrestrequest", // 申请休店
  getOffStatus: "/system/shop/findrestdetail", // 当前店铺状态
  // 2、发货规则
  getRuleDetail: "/system/shop/shippingruledetail", //店铺发货规则信息
  submitRule: "/system/shop/submitshippingrulerequest", //提交规则
  getRuleList: "/system/shop/shippingrulelistforshop", //规则列表
  // 3、报备
  getDelayEnum: "/system/shop/shippingdelayreasonenum", //延迟原因枚举
  getStatusEnum: "/system/shop/shippingdelaystatusenum", // 状态枚举
  getReportList: "/system/shop/shippingdelaylistforshop", //报备列表
  cancelReport: "/system/shop/rejectedshippingdelayrequest", //撤消报备
  submitReport: "/system/shop/submitshippingdelayrequest", //提交报备
  getReportDetail: "/system/shop/shippingdelayrequestinfo", //报备详情
  orderList: "/system/order/shippingdelayrequestselectorderlist", //受影响订单
  uploadImage: "/system/other/uploadimage", //上传图片
  uploadOrder: "/system/order/importshippingdelayrequestselectorderlist" //上传订单文件
};
export default orderReportApi;



// WEBPACK FOOTER //
// ./src/service/basic/orderReportApi.js